import { render, staticRenderFns } from "./ConversationHead.vue?vue&type=template&id=37a9dbdc&scoped=true"
import script from "./ConversationHead.vue?vue&type=script&lang=js"
export * from "./ConversationHead.vue?vue&type=script&lang=js"
import style0 from "./ConversationHead.vue?vue&type=style&index=0&id=37a9dbdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a9dbdc",
  null
  
)

export default component.exports